import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaUser, FaShoppingBag, FaHeart, FaBell } from "react-icons/fa";
import axios from "axios";
import "../../../assets/css/general/MyNavbar.css";
import BottomNavigation from "../bottomnavigation/BottomNavigation";
import AppContext from "../../../contexts/AppContext";

const MyNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    isAuthenticated,
    customer,
    unreadCounts,
    clearUnread,
    setUnreadCount,
    baseUrl,
    customerAuthToken,
  } = useContext(AppContext);

  const handleNavigation = (path) => {
    if (location.pathname !== path) navigate(path);
  };

  useEffect(() => {
    if (!isAuthenticated) return;

    const storedCustomer = JSON.parse(localStorage.getItem("loggedInCustomer"));
    if (!storedCustomer?.id) return;

    const formdata = new FormData();
    // Fixed: was "chcustomer_id" (typo) — backend expects "customer_id"
    formdata.append("customer_id", storedCustomer.id);

    axios
      .post(`${baseUrl}/customer/order/getCustomerNotifications`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${customerAuthToken}`,
        },
      })
      .then((res) => {
        const unread = (res.data.notifications || []).filter(
          (n) => n.status === "unread",
        ).length;
        setUnreadCount("notifications", unread);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [isAuthenticated, baseUrl, customerAuthToken]);

  return (
    <>
      <nav className="clean-navbar">
        <div className="clean-nav-container">
          <div className="clean-logo" onClick={() => handleNavigation("/")}>
            CRAFTHIVE
          </div>

          <ul className="clean-nav-menu">
            <li
              className={location.pathname === "/" ? "active" : ""}
              onClick={() => handleNavigation("/")}
            >
              Home
            </li>
            <li
              className={location.pathname === "/categories" ? "active" : ""}
              onClick={() => handleNavigation("/categories")}
            >
              Categories
            </li>
            <li
              className={location.pathname === "/shops" ? "active" : ""}
              onClick={() => handleNavigation("/shops")}
            >
              Shops
            </li>
            <li
              className={location.pathname === "/about" ? "active" : ""}
              onClick={() => handleNavigation("/about")}
            >
              About us
            </li>
            <li
              className={location.pathname === "/contact" ? "active" : ""}
              onClick={() => handleNavigation("/contact")}
            >
              Contact us
            </li>
            <li
              className={location.pathname === "/become-seller" ? "active" : ""}
              onClick={() => handleNavigation("/become-seller")}
            >
              Become a Seller
            </li>
          </ul>

          <div className="clean-nav-right">
            {isAuthenticated ? (
              <div className="authenticated-nav">
                {/* ── Notifications Bell ── */}
                <div
                  className="nav-icon-wrapper notification-bell"
                  onClick={() => {
                    handleNavigation("/notifications");
                    clearUnread("notifications");
                  }}
                  title="Notifications"
                  style={{ position: "relative" }}
                >
                  <FaBell className="nav-icon" />

                  {unreadCounts.notifications > 0 && (
                    <span className="nav-badge">
                      {unreadCounts.notifications}
                    </span>
                  )}
                </div>

                {/* ── Favourites Icon ── */}
                <div
                  className="nav-icon-wrapper"
                  onClick={() => {
                    handleNavigation("/favorites");
                    clearUnread("favourites");
                  }}
                  title="Wishlist"
                  style={{ position: "relative" }}
                >
                  <FaHeart className="nav-icon" />
                  {unreadCounts.favourites > 0 && (
                    <span className="nav-badge">{unreadCounts.favourites}</span>
                  )}
                </div>

                {/* ── Cart Icon ── */}
                <div
                  className="nav-icon-wrapper"
                  onClick={() => {
                    handleNavigation("/cart");
                    clearUnread("cart");
                  }}
                  title="Shopping Cart"
                  style={{ position: "relative" }}
                >
                  <FaShoppingBag className="nav-icon" />
                  {unreadCounts.cart > 0 && (
                    <span className="nav-badge">{unreadCounts.cart}</span>
                  )}
                </div>

                {/* ── User Icon ── */}
                <div
                  className="nav-icon-wrapper"
                  onClick={() => handleNavigation("/account")}
                  title="My Account"
                >
                  <FaUser className="nav-icon" />
                </div>

                <div className="user-info">
                  <span className="user-display-name">
                    {customer?.first_name} {customer?.last_name}
                  </span>
                  <span className="user-display-email">{customer?.email}</span>
                </div>
              </div>
            ) : (
              <>
                <button
                  className="user-login-button"
                  onClick={() => handleNavigation("/login")}
                >
                  Login
                </button>
                <button
                  className="register-button"
                  onClick={() => handleNavigation("/signup")}
                >
                  Signup
                </button>
              </>
            )}
          </div>
        </div>
      </nav>

      <BottomNavigation />
    </>
  );
};

export default MyNavbar;